// extracted by mini-css-extract-plugin
module.exports = {"modal":"ResetConfirmationModal__modal--2Aqev"};